<template>
    <div v-if="1==2" class="p-2 block sm:ml-24 max-w-7xl text-center border border-sepBorder rounded-lg h-full mt-2 py-5 pb-36 overflow-auto dark:text-dark.textOnBkg dark:border-dark.sepBorder">
        <h1 class="text-2xl font-bold mb-2">Add-ons</h1>
        <MazTabs v-model="selectedTab">
            <MazTabsBar :items="platformTabs" persistent class="mb-2" />
            <MazTabsContent>
                <div><!-- Wrap in a div to handle transitions properly -->
                    <transition name="tab-transition" mode="out-in">
                        <div :key="selectedTab" class="transition-wrapper">
                            <component :is="currentTabComponent" :platform="selectedPlatform"/>
                        </div>
                    </transition>
                </div>
            </MazTabsContent>
        </MazTabs>
    </div>
    <div class="p-2 block sm:ml-24 py-32 max-w-7xl text-center border border-sepBorder rounded-lg h-full mt-2 py-5 pb-36 overflow-auto dark:text-dark.textOnBkg dark:border-dark.sepBorder">
        In development
    </div>
</template>

<script>
import { useAuthStore } from '@/stores/auth';
import AccountTable from '@/components/addons/AccountTable.vue';

export default {
    name: 'AddOns',
    components: {
        AccountTable,
    },
    data() {
        return {
            selectedTab: 1,
            platformTabs: [
                { label: 'OnlyFans', value: 'onlyfans' },
                { label: 'Fansly', value: 'fansly' },
            ],
        };
    },
    computed: {
        authStore() {
            return useAuthStore();
        },
        myself() {
            return this.authStore.myself;
        },
        permissions() {
            return this.authStore.permissions;
        },
        selectedPlatform() {
            return this.platformTabs[this.selectedTab - 1]?.value || 'onlyfans';
        },
        currentTabComponent() {
            return AccountTable;
        }
    },
};
</script>

<style scoped>
    .tab-transition-enter-active,
    .tab-transition-leave-active {
        transition: all 0.3s ease;
    }

    .tab-transition-enter-from,
    .tab-transition-leave-to {
        opacity: 0;
        transform: translateY(10px);
    }
</style>
